import { render, staticRenderFns } from "./conversation-preview-item.vue?vue&type=template&id=325460b1&"
import script from "./conversation-preview-item.vue?vue&type=script&lang=js&"
export * from "./conversation-preview-item.vue?vue&type=script&lang=js&"
import style0 from "./conversation-preview-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports